import { Box, Typography } from '@mui/material'

const ChannelDisabled = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        p: 4,
        textAlign: 'center',
      }}
    >
      <Typography variant="h4" gutterBottom>
        Page introuvable
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Cette page n&apos;est pas disponible pour le moment.
      </Typography>
    </Box>
  )
}

export default ChannelDisabled
